import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'

export default class MeatInspection extends React.Component {
  resource = '/moen/health/meat_inspections'
  form_key = 'meat_inspection'
  defaults = {}

  // Delete lines as needed
  fee = 99
  free = true
  postpaid = true
  skip_location = true
  hide_buttons = false
  custom_actions = []

  validate = null

  foremost = null

  slaughteredCalculator = (form) => {
    let sheep_qty = 0;
    let goat_qty = 0;
    let pig_qty = 0;
    let cattle_qty = 0;
    let total_qty = 0;

    if (form.sheep_qty) {
      sheep_qty = parseInt(form.sheep_qty)
    }
    if (form.goat_qty) {
      goat_qty = parseInt(form.goat_qty)
    }
    if (form.pig_qty) {
      pig_qty = parseInt(form.pig_qty)
    }
    if (form.cattle_qty) {
      cattle_qty = parseInt(form.cattle_qty)
    }
    total_qty = sheep_qty + goat_qty + pig_qty + cattle_qty

    return {
      total_slaughtered: parseInt(total_qty) || 0
    }
  }

  fields = form => [
    {
        name: "animals_slaughtered",
        options: [
            {label: "SHEEP", value: "sheep"},
            {label: "GOATS", value: "goats"},
            {label: "PIGS", value: "pigs"},
            {label: "CATTLE", value: "cattle"},
        ],
         multi: true
    },
    {
        name: "sheep_qty",
        label: "Sheep Slaughtered",
        type: "integer",
        hide: !form.animals_slaughtered?.includes('sheep'),
        hint: 'Quantity of sheep slaughtered',
        onBlur: async (v) => {
            return this.slaughteredCalculator(form)
        },
    },
    {
        name: "goat_qty",
        label: "Goats Slaughtered",
        type: "integer",
        hide: !form.animals_slaughtered?.includes('goats'),
        hint: 'Quantity of goats slaughtered',
        onBlur: async (v) => {
            return this.slaughteredCalculator(form)
        },
    },
    {
        name: "pig_qty",
        label: "Pigs Slaughtered",
        type: "integer",
        hide: !form.animals_slaughtered?.includes('pigs'),
        hint: 'Quantity of pigs slaughtered',
        onBlur: async (v) => {
            return this.slaughteredCalculator(form)
        },
    },
    {
        name: "cattle_qty",
        label: "Cattle Slaughtered",
        type: "integer",
        hide: !form.animals_slaughtered?.includes('cattle'),
        hint: 'Quantity of cattle slaughtered',
        onBlur: async (v) => {
            return this.slaughteredCalculator(form)
        },
    },
    {
        name: "total_slaughtered",
        label: "Total Animals Slaughtered",
        type: "integer",
        hint: 'Total quantity of animals slaughtered',
        disabled: true,
    },
    {
        name: "carcasses_condemned_list",
        fields: [
            {   
                name: "animal",
                label: "ANIMAL",
                options: [
                    {label: "SHEEP", value: "sheep"},
                    {label: "GOATS", value: "goats"},
                    {label: "PIGS", value: "pigs"},
                    {label: "CATTLE", value: "cattle"},
                ],
            },
            {name: "quantity", label: "QUANTITY", type: "integer"},
            {name: "cause", label: "CAUSE"},
            {name: "total", label: "TOTAL", type: "integer"},
            // {name: "grand_total", label: "GRAND TOTAL", type: "integer"},
        ]
    },
    {
        name: "parts_condemned_list",
        fields: [
            {name: "parts", label: "PARTS"},
            {name: "reason for condemnation", label: "REASON FOR CONDEMNATION"},
            {name: "sheep", label: "SHEEP"},
            {name: "goats", label: "GOATS"},
            {name: "pigs", label: "PIGS"},
            {name: "cattle", label: "CATTLE"},
            {name: "total", label: "TOTAL", type: "integer"},
            // {name: "grand_total", label: "GRAND TOTAL", type: "integer"},
        ]
    },
    {
        name: "date",
        type: "date",
        showDropdwnYear: true
    }
   
]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
